import { useState } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { createGlobalStyle } from 'styled-components';
import { z } from 'zod';
import './App.css';
import ErrorBoundary from './App.error';
import { Router } from './App.routing';
import { AuthContext, AuthContextType } from './contexts/AuthContext';
import { ResponsiveContext } from './contexts/ResponsiveContext';
import useMediaQuery from './hooks/UseMediaQuery';
import { ErrorModal } from './shared/error-modal/ErrorModal';
import MainLayout from './shared/layout/MainLayout';
import StyleData from './utilities/StyleData';

export const defaultErrorMap: z.ZodErrorMap = (issue, ctx) => {
  if (issue.code === z.ZodIssueCode.invalid_type) {
    return { message: 'Le champ est requis.' };
  }
  if (issue.code === z.ZodIssueCode.custom) {
    return { message: `less-than-${(issue.params || {}).minimum}` };
  }
  return { message: ctx.defaultError };
};

z.setErrorMap(defaultErrorMap);

const GlobalStyle = createGlobalStyle`
  body {
    // font-face loaded in index.css to prevent re-render in dev mode
    font-family: ${StyleData.font.primary};
    font-synthesis: none;
    margin: 0;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu',
    'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  `;

export default function App(): JSX.Element {
  const isMobileSize = useMediaQuery(StyleData.breakpoints.max.md, 'down');

  const [authContext, setAuthContext] = useState<AuthContextType>({
    authenticated: false,
    readOnly: true,
    loading: true,
    user: undefined,
  });

  return (
    <>
      <ErrorBoundary>
        <GlobalStyle />
        <ResponsiveContext.Provider value={{ isMobile: isMobileSize }}>
          <AuthContext.Provider value={authContext}>
            <BrowserRouter>
              <MainLayout>
                <Router setAuthContext={setAuthContext} />
              </MainLayout>
            </BrowserRouter>
            <ToastContainer autoClose={5000} />
          </AuthContext.Provider>
        </ResponsiveContext.Provider>
        <ErrorModal modalSize={'md'} actionText="Fermer" />
      </ErrorBoundary>
    </>
  );
}
